
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, computed } from 'vue'
import { useRoute } from 'vue-router'
export default defineComponent({
  props: {
    nodatadesc: {
      type: String,
      default: () => {
        return ''
      }
    },
    customdesc: {
      type: String,
      default: () => {
        return ''
      }
    },
    mode: {
      type: String,
      default: () => {
        return 'horizontal'
      }
    },
    isShowSJ: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    pagetheme: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  setup(props, context) {
    const route = useRoute()
    const pageData: any = reactive({
      theme: route.query.theme,
      img: ''
    })
    if (props.mode === 'vertical') {
      const theme = pageData.pagetheme ? pageData.pagetheme : pageData.theme
      if (theme === 'dark') {
        pageData.img = require('@/assets/nodata_dark_v.png')
      } else {
        pageData.img = require('@/assets/nodata_light_v.png')
      }
    }
    return {
      ...toRefs(pageData)
    }
  }
})
